export const environment = {
  production: true,
  auth: {
    redirectUri: 'https://dev-vendors.mtjr.ly/',
    postLogoutRedirectUri: 'https://dev-vendors.mtjr.ly/',
    resource: 'https://vendors.mtjr.ly',
  },
  baseUrl: 'https://dev-vapi.mtjr.ly',
  shareBaseUrl: 'https://dev-share.mtjr.ly',
};
